// @ts-nocheck
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  startSessionRecording,
  stopSessionRecording,
  setCurrentScreen,
} from "../service/sessionReplay/sessionRecorder";

function screenNameFromPath(pathname) {
  const path = (pathname || "").replace(/^\/+/, "").toLowerCase();
  const segments = path.split("/").filter((s) => s && !/^\d+$/.test(s));
  if (!segments.length) return "Home";
  return segments
    .slice(0, 2)
    .join(" ")
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function useSessionRecorderGate() {
  const location = useLocation();

  useEffect(() => {
    startSessionRecording();
    return () => {
      stopSessionRecording("explicit");
    };
  }, []);

  useEffect(() => {
    setCurrentScreen(screenNameFromPath(location.pathname), location.pathname);
  }, [location.pathname]);
}

export default useSessionRecorderGate;
